export const ERRORS = {
  INVALID_PHONE: 'Некорректный номер телефона',
  INVALID_MIN_PHONE_NUMBER: 'Введите полный номер',
  INVALID_EMAIL: 'Некорректный email',
  REQUIRED: 'Обязательное поле',
  PASSWORD_MIN_LENGTH: 'Пароль должен быть не менее 8 символов',
  PASSWORD_WEAK:
    'Должен содержать хотя бы одну заглавную и одну строчную букву, одну цифру и один спецсимвол',
  PASSWORD_MISMATCH: 'Пароль должен совподать',
  INVALID_DATE: 'Некорректная дата',
  INVALID_TIME: 'Некорректное время',
  EVENT_TIME_END_BEFORE_START: 'Время окончания должно быть позже начала',
  FUTURE_DATE_NOT_ALLOWED: 'Дата рождения не может быть в будущем',
  INVALID_FIO:
    'ФИО должно содержать от 3 до 100 символов и включать только кириллические буквы, пробелы и дефисы',
  INVALID_NICKNAME:
    'Пользовательское имя должно быть на латинице и может содержать дефис, цифры, подчеркивание',
  INVALID_CYRILLIC_TEXT: 'Не должен включать латиницу',
  INVALID_MEDIA_TYPE: 'Некорректный тип медиа',
  INVALID_MODULE_SLUG:
    'Слаг: латиница в нижнем регистре, цифры и _, с буквы, до 100 символов; не совпадать со встроенными модулями',
}
